import RoomOptionsArea from "./RoomOptionsArea.js";
import ConfirmationArea from "./ConfirmationArea.js";
import RoomArea from "./RoomArea.js";
import UserArea from "./UserArea.js";

import Error from "../utils/Error.js";

import global from "../global.js";

import StateMachine from "statemachine";

const log = global.log.getLogger("f_mtac.ui.StatusArea");
log.setLevel(log.levels.WARN);

let StatusArea = function () {
    Object.defineProperty(this, "state", {
        get: () => sm.state.name,
        set: () => {}
    });
    Object.defineProperty(this, "space_name", {
        set: (name) => {
            $("#status_area span.room-name").text(name || global.internationalization.text("global.Without-name")); // if falsy
        },
        get: () => $("#status_area span.room-name").text()
    });
    Object.defineProperty(this, "room", {
        set: (room) => {
            $("#status_area .room-short-id").data("room", room);
            $("#status_area .room-short-id").html(room === null ? "" : room.short_id);
        },
        get: () => $("#status_area span.room-short-id").data("room")
    });
    let sm = new StateMachine({
        name: "connection_state",
        shared_data: {},
        default_state: "disconnected",
        states: {
            disconnected: {
                in: () => {
                    $("#status_area > div.container-fluid").addClass("mtac-status-disconnected");
                    $("meta[name=theme-color]").attr("content", "white");
                },
                out: () => {
                    $("#status_area > div.container-fluid").removeClass("mtac-status-disconnected");
                },
                transit: {
                    connect: {
                        state: "connected",
                        handler: () => {
                            return Promise.resolve(true);
                        }
                    },
                    connection_loss: {
                        state: "connection_lost",
                        handler: () => {
                            return Promise.resolve(true);
                        }
                    }
                },
                schedule: {
                    /*none_timer: {
                        handler: (schedule_data) => {
                            log.info("polling none ", schedule_data);
                        },
                        interval: 500,
                        repeat: Infinity
                    }*/
                }
            },
            connected: {
                in: (state_data) => {
                    log.info("going in state connected ", state_data);
                    $("#status_area > div.container-fluid").addClass("mtac-status-connected");
                    $("meta[name=theme-color]").attr("content", "hsl(79.1, 97.38%, 60%)");
                    if (global.server.network.state === "offline") {
                        sm.transition.connection_lost({});
                    }
                },
                out: (state_data) => {
                    log.info("going out state connected ", state_data);
                    $("#status_area > div.container-fluid").removeClass("mtac-status-connected");
                },
                transit: {
                    disconnect: {
                        state: "disconnected",
                        handler: () => {
                            return this.disconnect();
                        }
                    },
                    connection_loss: {
                        state: "connection_lost",
                        handler: () => {
                            return Promise.resolve(true);
                        }
                    }
                },
                schedule: {
                    none_timer: {
                        handler: (schedule_data) => {
                            log.info("polling none ", schedule_data);
                        },
                        interval: 5000000,
                        repeat: Infinity
                    }
                }
            },
            connection_lost: {
                in: (state_data) => {
                    log.info("going in state connection_lost ", state_data);
                    $("#status_area > div.container-fluid").addClass("mtac-status-connection_lost");
                    $("meta[name=theme-color]").attr("content", "hsl(0, 100%, 50%)");
                },
                out: (state_data) => {
                    log.info("going out state connection_lost ", state_data);
                    $("#status_area > div.container-fluid").removeClass("mtac-status-connection_lost");
                },
                transit: {
                    disconnect: {
                        state: "disconnected",
                        handler: () => {
                            if (global.storage.selected_space.room !== null) {
                                return this.disconnect();
                            } else {
                                return Promise.resolve(true);
                            }
                        }
                    },
                    reconnect: {
                        state: "connected",
                        handler: () => {
                            log.info("Storage.sm reconnect to room", global.storage.selected_space.room);
                            if (global.storage.selected_space.room !== null) return Promise.resolve(true);
                            else return Promise.resolve(false);
                        }
                    }
                },
                schedule: {}
            }
        }
    });

    this.disconnect = async function () {
        if (!global.storage.shared()) {
            log.error("already disconnected");
            return true;
        }
        let space = global.storage.selected_space;
        if (space === null) {
            return false;
        }
        let space_room = space.room;
        await global.storage.unshare();
        try {
            await global.server.mtac_room_disconnect(space_room);
        } catch (error) {
            switch (error.status) {
                case Error.status.access:
                    log.warn("disconnecting from a share after a deregistration");
                    break;
                case Error.status.noent:
                    log.warn("the share doesn't exist on the server");
                    break;
                case Error.status.netdown:
                case Error.status.hostdown:
                    log.warn("disconnecting from a share while offline");
                    break;
                default:
                    throw error;
            }
        }

        // Agnet : remove all msisdn resources
        global.storage.selected_space.delete_agnet_resources_in_all_context();

        return true;
    };

    this.refresh_logo = async function () {
        log.debug(`StatusArea.refresh_logo: uri = ${global.commissioning.uri.logo}`);
        await fetch(global.commissioning.uri.logo, {cache: "reload"})
            .then((logo) => logo.text())
            .then((logo_text) => new DOMParser().parseFromString(logo_text, "application/xml"))
            .then((logo) => {
                log.debug("StatusArea.refresh_logo: update DOM", {logo});
                $("#status_area .logo").empty(); // remove if any
                $("#status_area .logo").html(); // remove if any
                $("#status_area .logo")[0].append(logo.documentElement);
            });
    };

    // global.event_bus.subscribe("init", () => {
    global.event_bus.subscribe("network.offline", () => {
        // going offline
        if (global.storage.shared()) {
            sm.transition.connection_lost({});
        } else {
            // keep disconnected state ?
        }
    });

    global.event_bus.subscribe("network.online", () => {
        log.debug("StatusArea -> on network.online");
        // back online
        if (global.storage?.shared()) {
            sm.transition.connected({});
        } else {
            sm.transition.disconnected({});
        }
    });

    global.event_bus.subscribe("storage.shared", ({room}) => {
        log.debug("StatusArea -> on storage.shared", {room});
        this.room = room;
        if (global.server.network.state === "online") {
            sm.transition.connected({});
        } else {
            sm.transition.connection_lost({});
        }
    });

    global.event_bus.subscribe("storage.unshared", () => {
        sm.transition.disconnected({});
        this.room = null;
    });

    global.event_bus.subscribe("storage.space.changed", ({new_space}) => {
        log.debug("StatusArea -> on storage.space.changed", {new_space});
        this.space_name = new_space?.name ?? ""; // if nullish
        this.room = new_space?.room ?? null;
        // Fix AGPOC-3519 - shared space name lost after application is stopped
        // not sure it is the best place to do that
        new_space.data_commit();
    });

    global.event_bus.subscribe("storage.space.updated", ({space}) => {
        log.debug("StatusArea -> on storage.space.updated", {space});
        this.space_name = space.name;
        this.room = space.room;
    });

    global.event_bus.subscribe("internationalization.language.changed", () => {
        this.space_name = global.storage.selected_space?.name;
    });

    global.event_bus.subscribe("init", () => {
        log.debug("StatusArea -> on init");
        let profileName = global.configuration.getProfileName(global.configuration.user.level);
        $("#status_area .user_name").text(`${global.configuration.user.name}`);
        $("#status_area .user_profile").html(profileName + $("#status_area .user_profile").html());

        this.space_name = global.storage.selected_space?.name;
        this.refresh_logo();

        $("body").on("click", "#status_area button.user", () => {
            let initialLevel = global.configuration.user.level;
            let initialPofileName = global.configuration.getProfileName(initialLevel);
            UserArea.interact({enable_cancel: true}).then((user) => {
                $("#status_area .user_name").text(`${user.name}`);
                let newProfileName = global.configuration.getProfileName(user.level);
                let new_html = $("#status_area .user_profile").html().replace(initialPofileName, newProfileName);
                $("#status_area .user_profile").html(new_html);
                if (user.level !== initialLevel) {
                    global.event_bus.publish("user.level.changed", {level: user.level});
                }
            });
        });

        $("body").on("click", "#status_area button.room", async () => {
            RoomArea.interact();
        });

        $("body").on("click", "button[data-method='share']", async () => {
            if (global.storage.selected_space.room !== null) {
                const confirmation = await ConfirmationArea.interact({
                    title: global.internationalization.text("global.Warning"),
                    tip1: global.internationalization.text("collaboration.Stop-ongoing-sharing"),
                    tip2: ""
                });
                if (confirmation) {
                    sm.transition.disconnected({});
                }
            } else {
                RoomOptionsArea.interact();
            }
        });
    });
};

export default new StatusArea();
